export default "__VITE_ASSET__DsevS2Bd__"